import React, { Component, Fragment } from 'react';
import { drapcodeIcon } from '../../common/custom/icon-library';
import * as actions from './redux/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ListLayouts from './ListLayouts';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import LayoutForm from './LayoutForm';

export class Layout extends Component {
  state = { isAddNewLayout: false };

  addNewLayout = () => {
    this.setState({ isAddNewLayout: true });
  };

  closeNewLayout = () => {
    this.setState({ isAddNewLayout: false });
  };

  layoutOptions = () => {
    return [
      { label: 'Header', value: 'header' },
      { label: 'Sidebar', value: 'sidebar' },
      { label: 'Footer', value: 'footer' },
    ];
  };

  handleSubmit = async (values) => {
    const { projectId, version } = this.props;
    await this.props.actions.saveLayout({ projectId, version, data: values });
    this.closeNewLayout();
  };

  handleLayoutUpdate = async (values, uuid) => {
    const { projectId, version } = this.props;
    await this.props.actions.updateLayout({ projectId, version, data: values, uuid });
  };

  handleDelete = (uuid) => {
    const { projectId, version, actions } = this.props;
    actions.deleteLayout({ projectId, version, uuid });
  };

  render() {
    const { layouts, snippets, projectId } = this.props;
    return (
      <Fragment>
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="card">
            <div className="card-header card-header-icon" data-background-color="drapcode-violet">
              <i className={`wb ${drapcodeIcon('form')}`}></i>
            </div>
            <div className="card-content">
              <div className="card-title-header">
                <h4 className="card-title">Page Snippet Layouts</h4>
                <div className="card-cta">
                  <button
                    type="button"
                    className="btn btn-theme-submit btn-md"
                    onClick={this.addNewLayout}
                  >
                    <i className={`wb ${drapcodeIcon('add')}`}></i> Add Snippet Layout&nbsp;
                  </button>
                </div>
              </div>
              {layouts && layouts.length > 0 && (
                <ListLayouts
                  layouts={layouts}
                  snippets={snippets}
                  handleDelete={this.handleDelete}
                  handleLayoutUpdate={this.handleLayoutUpdate}
                />
              )}
              {this.state.isAddNewLayout && (
                <Accordion>
                  <AccordionItem dangerouslySetExpanded>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <i className={`wb`}></i> <strong>{'New Layout'}</strong>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <LayoutForm
                        handleSubmit={this.handleSubmit}
                        snippets={snippets}
                        closeNewLayout={this.closeNewLayout}
                      />
                    </AccordionItemPanel>
                  </AccordionItem>
                </Accordion>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
